<mat-dialog-content>
  <lemon-dialog-header> Valitse uusi päivämäärä </lemon-dialog-header>

  <div class="tosite-tiedot">
    <form novalidate style="margin: 0">
      <mat-form-field>
        <mat-label>Päivämäärä</mat-label>
        <input type="text" [max]="viimeinenPaiva" [min]="ensimmainenPaiva" [matDatepicker]="picker" [formField]="lomake.kirjauksenPvm" matInput data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-error>Päivämäärä puuttuu</mat-error>
      </mat-form-field>
      <mat-datepicker #picker></mat-datepicker>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 0; padding-right: 0; justify-content: space-around; justify-content: space-evenly">
  <app-secondary-button [focusRegionStart]="true" mat-dialog-close actionId="Peruuta (kirjauksen pvm:n muutos dialog)">Peruuta</app-secondary-button>
  <app-primary-button (click)="muuta()" actionId="Muuta kirjauksen päivämäärä" [actionContext]="$any(lomake().value())">Muuta päivämäärä</app-primary-button>
</mat-dialog-actions>
